import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShareGoalQuery, ShareGoalQueryVariables } from './shareGoal.graphql';
import { ShareGoal } from './shareGoal.graphql';

export async function prefetchShareGoal(
	{ gql: { fetch }, errorReporter: { report } }: UtilityContext,
	petitionId: string,
): Promise<number | null> {
	try {
		const { data } = await fetch<ShareGoalQuery, ShareGoalQueryVariables>({
			query: ShareGoal,
			variables: { petitionId },
			rejectOnError: true,
		});
		return data.shareGoal?.shareGoal?.goalValue ?? null;
	} catch (error) {
		void report(new Error('Failed to prefetch sharing goal', { cause: error }));
		return null;
	}
}
